import React from "react";
import Widget from "./component/Widget";
import TaxHelp from "./component/TaxHelp";
import ExpenseSummary from "./component/IncomeExpenseSummary";
import Login from "./component/Login";
import Signup from "./component/Signup";
import Resources from "./component/Resources";
import ResourceViewer from "./component/ResourceViewer";
import Guides from "./component/Guides";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./lib/useAuth";
import "./App.css";

// Protected Route: Only logged in users can access
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="text-pink-400 font-bold">Loading...</div>;
  return user ? children : <Navigate to="/" />;
};

// Public Route: Only guests (not logged in) can access
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="text-pink-400 font-bold">Loading...</div>;
  return !user ? children : <Navigate to="/tax-help" />;
};

function App() {
  return (
    <div className="bg-gray-200 min-h-screen flex items-center justify-center p-0 sm:p-4 md:p-6 w-full">
      <div className="w-full sm:max-w-xl flex justify-center">
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/signup" element={<PublicRoute><Signup /></PublicRoute>} />

            {/* Protected Routes */}
            <Route path="/tax-help" element={<ProtectedRoute><TaxHelp /></ProtectedRoute>} />
            <Route path="/widget" element={<ProtectedRoute><Widget /></ProtectedRoute>} />
            <Route path="/expense-summary" element={<ProtectedRoute><ExpenseSummary /></ProtectedRoute>} />
            <Route path="/resources" element={<ProtectedRoute><Resources /></ProtectedRoute>} />
            <Route path="/resource/:url" element={<ProtectedRoute><ResourceViewer /></ProtectedRoute>} />
            <Route path="/guides" element={<ProtectedRoute><Guides /></ProtectedRoute>} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;

